











import { Vue, Component, Prop } from 'vue-property-decorator';

import { GridModel, GridFilter } from '@/core/models';

@Component
export default class GridSearchCpt extends Vue {
  @Prop() grid: GridModel<any, GridFilter>;
  @Prop({ default: 'Search' }) placeholder?: string;
  filter = null as GridFilter | null;
  debounce: number | undefined;

  created() {
    // Initialize filter from grid once component is created
    this.filter = this.grid.filter;
  }

  onChange(): void {
    clearTimeout(this.debounce);
    this.debounce = setTimeout(() => {
      this.grid.onSearch(this.filter);
    }, 350);
  }

  onClear() {
    this.grid.onSearch('');
  }
}
